import script from "./CourseIndexView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CourseIndexView.vue?vue&type=script&lang=ts&setup=true"

import "./CourseIndexView.vue?vue&type=style&index=0&id=83ee9448&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83ee9448"]])

export default __exports__